import React from "react";

function OfferSkeletonCard({ slider = false }) {
    if (slider) {
        return (
            <div className="offer offer-skeleton offer-skeleton--slider">
                <div className="sk-line sk-title" />
                <div className="sk-line sk-price" />
                <div className="sk-line sk-img" />
                <div className="sk-line sk-spec-row" />
                <div className="sk-line sk-spec-row sk-spec-row--short" />
                <div className="sk-line sk-btn" />
            </div>
        );
    }
    return (
        <div className="offer offer-skeleton">
            <div className="sk-line sk-img" />
            <div className="sk-line sk-title" />
            <div className="sk-line sk-spec-row" />
            <div className="sk-line sk-spec-row sk-spec-row--short" />
            <div className="sk-line sk-price" />
            <div className="sk-line sk-btn" />
        </div>
    );
}

export default OfferSkeletonCard;
